<template>
  <el-row :gutter="10" style="margin-bottom: 10px">
    <el-col :span="4">
      <el-date-picker
          v-model="selectMonth"
          style="width: 100%"
          type="month"
          placeholder="请选择月份"
          value-format="YYYY-MM"
      />
    </el-col>
    <el-col :span="4">
      <el-input v-model="employeeNo" placeholder="员工工号"/>
    </el-col>
    <el-col :span="4">
      <el-input v-model="employeeName" placeholder="员工姓名"/>
    </el-col>
    <el-col :span="6">
      <el-button type="primary" @click="getPlan" style="margin-left: 20px" :loading="loading" >搜索</el-button>
      <el-button type="primary" @click="savePlanDtl" :loading="saveLoading" >保存</el-button>
      <el-button type="primary" plain @click="exportTableData">导出</el-button>
    </el-col>
  </el-row>

  <el-table :data="planList" stripe border fit style="width: 100%;;height: 80%" row-style="height:35px;" size="small">
    <el-table-column label="工号" prop="employee_no" fixed width="100" align="center"></el-table-column>
    <el-table-column label="姓名" prop="employee_name" fixed width="100" align="center"></el-table-column>
    <el-table-column label="部门" prop="department_name" fixed width="200" align="center"></el-table-column>
    <el-table-column label="岗位" prop="job_id" fixed width="110" align="center"></el-table-column>
    <el-table-column label="职务" prop="position_id" fixed width="110" align="center"></el-table-column>
    <el-table-column label="工作日" prop="workCount" fixed width="60" align="center"></el-table-column>
    <el-table-column label="休息日" prop="breakCount" fixed width="60" align="center"></el-table-column>
    <el-table-column label="排班类型" prop="plan_type" fixed width="70" align="center"></el-table-column>
    <el-table-column v-for="title in titleList" :label="title.day" :prop="title.day" :key="title.day"
                     align="center" width="30">
      <el-table-column :label="title.calendar" :prop="title.day" :key="title.day" align="center" show-overflow-tooltip width="60">
        <el-table-column :label="title.week" :prop="title.day" :key="title.day" align="center" show-overflow-tooltip width="60">
          <template #default="scope">
            <el-popover
                placement="bottom"
                :width="200"
                :visible="isPopoverVisible(scope.row.id, title.day)"
                popper-class="attendance-popover"
                ref="`popover_${scope.row.id}_${title.day}`"
            >
              <template #reference>
                <div
                    class="cell-text"
                    :class="{ 'edited-cell': isCellEdited(scope.row, title.day) }"
                    style="cursor: pointer; min-height: 24px;"
                    @click="togglePopover(scope.row.id, title.day)">
                  {{scope.row[title.day]}}
                </div>
              </template>

              <div style="padding: 10px;">
                <div class="class-options-list">
                  <div
                      v-for="item in classList"
                      :key="item.id"
                      class="class-option-item"
                      :class="{ 'selected': scope.row[title.day] === item.attendance_name }"
                      @click="selectClass(scope.row, title.day, item)"
                  >
                    {{ item.attendance_name }}
                  </div>
                </div>
              </div>
            </el-popover>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table-column>
  </el-table>
<div style="display: flex;justify-content: flex-end;margin-top: 5px">
    <el-pagination background layout="  total"
                   v-model:page-size="pageSize"
                   :total="listSize"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"/>
  </div>
</template>

<script>

import moment from "moment/moment";

export default {
  name: "AttendancePlan",
  inject: ['$fn'],
  props: {
    componentParam: {
      type: String,
      required: true
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      importButton:{
        "component": "button",
        "type": "primary",
        "plain": true,
        "label": "导入排班",
        "click": "jsOpenWindow",
        "window": {"component": "frame/FrameForm", "type": "attendance_plan_import","title":"导入排班",
          "width":800,"height":350,"object_id_key":"selectMonth"}
      },
      editedCells: new Set(),
      currentPopover: null, // 当前打开的 popover 标识
      CascaderProp: {
        emitPath: false,
        label: "name",
        value: "id",
        checkStrictly:true
      },
      optionProps: {
        emitPath: false,
        value: 'type',
        label: 'name'
      },
      syncButton:{
        "component": "button",
        "type": "primary",
        "label": "同步排班数据",
        "click": "jsOpenWindow",
        "window": {"component": "frame/FrameForm", "type": "attendance_plan_sync_query","title":"同步钉钉排班",
          "width":800,"height":300}
      },
      // 当前正在编辑的单元格
      editingCell: {
        rowId: null,      // 员工ID 或 行索引
        date: null        // 日期，如 '2025-04-05'
      },
      loading: false,
      saveLoading: false,
      classList: [],
      titleList: [],
      planList: [],
      pagePlanList: [],
      deptId: '',
      planId: '',
      employeeNo: '',
      employeeName: '',
      deptCascader: [],
      editPlanList: [],
      selectMonth: moment(moment().month(moment().month())).format('YYYY-MM'),
      pageSize:15,
      listSize:0,
      currentPage:1,
      syncTime:''
    }
  },
  computed: {

  },
  methods: {
    // 计算工作日/休息日数量
    calculateEmployeeStats(employee) {
      let workdays = 0
      let holidays = 0
      this.titleList.forEach(title => {
        let classId = employee[title.day+"class_id"];
        if (classId !== null && classId && classId.length>0) {
          if ("break"!==classId) {
            workdays++
          } else if ("break"===classId) {
            holidays++
          }
        }
      })
      // 直接更新到员工对象
      employee.workCount = workdays;
      employee.breakCount = holidays;
    },
    // 切换 popover 显示状态
    togglePopover(rowId, day) {
      const key = `${rowId}_${day}`;
      this.currentPopover = this.currentPopover === key ? null : key;
    },

    // 判断 popover 是否应该显示
    isPopoverVisible(rowId, day) {
      return this.currentPopover === `${rowId}_${day}`;
    },
    // 获取单元格唯一标识
    getCellKey(rowId, date) {
      return `${rowId}_${date}`;
    },

    // 判断单元格是否被编辑过
    isCellEdited(row, date) {
      const cellKey = this.getCellKey(row.id, date);
      const result = this.editedCells.has(cellKey);
      return result;
    },
    // 判断是否正在编辑该单元格
    isEditing(row, date) {
      let result = this.editingCell.rowId === row.id && this.editingCell.date === date;
      return result;
    },

    // 开始编辑
    startEdit(row, date) {
      this.editingCell = { rowId: row.id, date };
    },
    // 结束编辑
    stopEdit() {
      this.editingCell = { rowId: null, date: null };
    },
    // 选择班次
    selectClass(row, day, classItem) {
      let oldName = row[day];
      let oldClassId = row[day+"class_id"];
      // 存班次名称到 row[day]
      row[day] = classItem.attendance_name;

      // 存班次ID到 row.class_id
      row[day+"class_id"] = classItem.id;

      // 标记该单元格已被编辑
      this.editedCells.add(this.getCellKey(row.id, day));

      //更新统计
      this.calculateEmployeeStats(row);

      // 关闭 popover
      this.currentPopover =null;

      if(oldName !== classItem.attendance_name){
        let editItem = {
          id:row[day+"id"],
          employee_no:row.employee_no,
          plan_id:row.plan_id,
          year:row.year,
          month:row.month,
          day:day,
          old_class_name:oldName,
          new_class_name:classItem.attendance_name,
          old_class_id:oldClassId,
          class_id:classItem.id
        }
        const existingIndex = this.editPlanList.findIndex(item => item.id === editItem.id);
        if (existingIndex !== -1) {
          this.editPlanList.splice(existingIndex, 1);
        }
        this.editPlanList.push(editItem)
      }
    },

    addClass(row,day,classId){
      const classObj = this.classList.find(c => c.attendance_name === classId);
      if (classObj) {
        // 存班次名称到 row[day]
        row[day] = classObj.attendance_name;

        // 存班次ID到
        row[day+"class_id"] = classObj.id;  // 或 row.class_id = classId

        // 标记该单元格已被编辑
        this.editedCells.add(this.getCellKey(row.id, day));
        // 可选：存完整对象
        // row.class_info = classObj;
      }
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.getPlan();
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getPlan();
    },
    getCurrentPageData(){
      if(!this.planList){
        return
      }

      let startIndex = (this.currentPage - 1) * this.pageSize;
      let endIndex = this.currentPage * this.pageSize;
      this.pagePlanList = this.planList.slice(startIndex, endIndex)

    },
    async getPlan() {
      //查询数据
      let params = {
        planId: this.parentData.id,
        employeeNo: this.employeeNo,
        employeeName: this.employeeName,
        selectMonth: this.selectMonth
      }
      console.log(params);
      this.loading = true;
      await this.$http('attendancePlanService.getAttendancePlanListNew', params,false).then(data =>{
        this.planList = data.planList;
        this.titleList = data.titleList;
        this.editPlanList =[];
        // 清除编辑标记
        this.editedCells.clear();
        this.listSize = data.planList.length;
        this.getCurrentPageData();
        this.loading = false;
      },errMsg =>{
        this.$message.error(errMsg)
        this.loading = false;
      })
    },
    async getLatestPlan() {
      let params = {selectMonth: this.selectMonth}
      this.$messageBox.confirm('同步时间较长，确定同步排班数据吗？','提示' , {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        this.loading = true;
        await this.$http('dingAttendanceService.getAllPlanList', params, false).then(() => {
          this.getPlan();
          this.$message.success("同步排班成功");
          this.loading = false;
        }, errMsg => {
          this.$message.error(errMsg)
          console.log(errMsg);//具体的message信息，等同⽤$axios时的error.message
          this.loading = false;
        })
      })
    },
    async getDepartmentCascader() {
      this.deptCascader = await this.$http("sysUserDepartmentService.getDepartmentData");
    },
    async getClassList() {
      this.classList = await this.$http("attendanceClassesService.getClassList");
    },
    async savePlanDtl() {
      if (!this.editPlanList || this.editPlanList.length === 0) {
        this.$message.error("没有需要保存的数据");
        return;
      }
      /*for (const item of this.editPlanList) {
        for (const day of this.titleList){
          const className = item[day.day];
          if(className === '' || className === null){
            this.$message.error("员工班次必须排满整个月");
            return;
          }
        }
      }*/
      let params = {
        plan_month: this.selectMonth,
        plan_dtl: this.editPlanList,
        titleList: this.titleList
      }
      console.log(params);
      this.saveLoading = true;
      await this.$http('attendancePlanService.savePlanDtl', params, false).then(rtn => {
        // 清除编辑标记
        this.editedCells.clear();
        this.editPlanList =[];
        //赋值
        this.getCurrentPageData();
        this.saveLoading = false;
      }, errMsg => {
        this.$message.error(errMsg);
        this.saveLoading = false;
      })
    },
    /*  exportTableData() {
        // 加载模板
        const templateWorkbook = XLSX.readFile('template.xlsx');
        const ws = templateWorkbook.Sheets[templateWorkbook.SheetNames[0]];

        // 数据部分
        const data = this.planList.map(row => {
          const rowData = [
            row.employee_no,
            row.employee_name,
            row.group_name,
            row.dept,
            row.position_name,
            row.year,
            row.month
          ];

          // 添加动态日期列的数据
          this.titleList.forEach(title => {
            rowData.push(row[title.day] || "");
          });

          return rowData;
        });

        // 将数据添加到工作表
        XLSX.utils.sheet_add_aoa(ws, data, { origin: "A3" }); // 数据添加到 A3 单元格开始的地方

        // 保存文件
        XLSX.writeFile(templateWorkbook, "table_data.xlsx");
      }*/

    async exportTableData() {
      let params = {
        planList: this.planList,
        titleList: this.titleList,
      }
      let sysFile = await this.$http("dingExportService.exportPlanListToExcel", params);
      window.location.href = sysFile.url;
    }
  },
  created() {
    this.getClassList();
    this.getPlan();
    this.getDepartmentCascader();
  }
}
</script>

<style scoped lang="less">
.cell-text {
  position: relative;
  box-sizing: border-box;
  min-height: 24px;
}

.edited-cell::after {
  content: '';
  position: absolute;
  right: 0;
  bottom: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 0 8px 8px;
  border-color: transparent transparent #ff4d4f transparent;
  pointer-events: none;

}

::v-deep .attendance-popover {
  padding: 0;
}

.class-options-list {
  max-height: 200px;
  overflow-y: auto;
}

.class-option-item {
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 4px;
  margin-bottom: 4px;

  &:hover {
    background-color: #f5f7fa;
  }

  &.selected {
    background-color: #ecf5ff;
    color: #409eff;
    font-weight: bold;
  }

  &:last-child {
    margin-bottom: 0;
  }
}
</style>